export const REPLAY_FX_EVENT = 'replay-fx'

export type ReplayFxEventType =
  | 'file-loading'
  | 'file-ready'
  | 'startup-prefetch-start'
  | 'startup-prefetch-ready'
  | 'prewarm-start'
  | 'prewarm-ready'
  | 'startup-settle'
  | 'playback-start'
  | 'playback-end'
  | 'seek-start'
  | 'seek-ready'
  | 'damage'
  | 'clear'

export type ReplayFxEventDetail = {
  type: ReplayFxEventType
  at: number
  label?: string
  intensity?: number
  durationMs?: number
  packets?: number
  replayTimeMs?: number
  wallMs?: number
  ready?: boolean
  // playback-start only: not the first start of this replay file, so the cue
  // skips the eye-blink CRT launch and keeps just the jolt
  repeat?: boolean
}

export type ReplayFxApi = {
  emit: typeof emitReplayFxEvent
  startShowcase: () => void
  stopShowcase: (clear?: boolean) => void
  nextShowcase: () => void
  previousShowcase: () => void
  showShowcase: (stage: number | string) => boolean
}

export const emitReplayFxEvent = (type: ReplayFxEventType, detail: Omit<Partial<ReplayFxEventDetail>, 'type' | 'at'> = {}) => {
  const at = typeof performance === 'undefined' ? Date.now() : performance.now()
  const eventDetail: ReplayFxEventDetail = {
    type,
    at,
    ...detail,
  }
  if (typeof customEvents === 'undefined') {
    if (typeof document === 'undefined') return
    document.dispatchEvent(new CustomEvent<ReplayFxEventDetail>(REPLAY_FX_EVENT, {
      detail: eventDetail
    }))
    return
  }
  customEvents.emit('replayFx', eventDetail)
}

declare global {
  // Global declarations require `var`; runtime ownership remains in ReplayFxOverlay.
  // eslint-disable-next-line no-var
  var __replayFx: ReplayFxApi | undefined
}
